import Vue from 'vue'

//export const baseApiUrl = 'http://172.22.217.169:9000'            // DEV
export const baseApiUrl = 'https://apifiscal.sigame.digital/api/'   // PROD
export const baseS3Url = 'https://nfse-sigame-digital.s3.amazonaws.com' 
export const userCredential = '__user_credential' 

// Mensagem de erro global generica 
export function showError(e) {
    if (e && e.response && e.response.data) {
        Vue.toasted.global.defaultError({ msg: e.response.data })
    } else if (typeof e === 'string') {
        Vue.toasted.global.defaultError({ msg : e })
    } else {
        Vue.toasted.global.defaultError()
    }
}

export default { baseApiUrl, baseS3Url, showError, userCredential }